// Multi-language dictionary for JK Invest Group
export const LANGS = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "ru", label: "RU" },
];

const dict = {
  nav: {
    properties: { es: "Propiedades", en: "Properties", de: "Immobilien", ru: "Объекты" },
    offmarket: { es: "Off-Market", en: "Off-Market", de: "Off-Market", ru: "Off-Market" },
    investments: { es: "Inversiones", en: "Investments", de: "Investments", ru: "Инвестиции" },
    rentals: { es: "Alquiler", en: "Rentals", de: "Mieten", ru: "Аренда" },
    services: { es: "Servicios", en: "Services", de: "Services", ru: "Сервисы" },
    about: { es: "Nosotros", en: "About", de: "Über uns", ru: "О нас" },
    contact: { es: "Contacto", en: "Contact", de: "Kontakt", ru: "Контакты" },
    admin: { es: "Admin", en: "Admin", de: "Admin", ru: "Админ" },
  },
  brand: {
    tagline: {
      es: "Inmobiliaria & Lifestyle en Mallorca",
      en: "Real Estate & Lifestyle in Mallorca",
      de: "Immobilien & Lifestyle auf Mallorca",
      ru: "Недвижимость и лайфстайл на Майорке",
    },
  },
  hero: {
    eyebrow: {
      es: "Establecidos en Mallorca",
      en: "Rooted in Mallorca",
      de: "Verwurzelt auf Mallorca",
      ru: "На Майорке",
    },
    title_a: {
      es: "Villas discretas.",
      en: "Discreet villas.",
      de: "Diskrete Villen.",
      ru: "Закрытые виллы.",
    },
    title_b: {
      es: "Servicio incondicional.",
      en: "Uncompromising service.",
      de: "Bedingungsloser Service.",
      ru: "Безупречный сервис.",
    },
    subtitle: {
      es: "Curamos villas, apartamentos y oportunidades off-market para clientes que valoran la privacidad y la calidad.",
      en: "We curate villas, apartments and off-market opportunities for clients who value privacy and craft.",
      de: "Wir kuratieren Villen, Apartments und Off-Market-Objekte für Kunden, die Diskretion und Handwerk schätzen.",
      ru: "Мы подбираем виллы, апартаменты и off-market объекты для тех, кто ценит приватность и качество.",
    },
    cta_browse: { es: "Ver propiedades", en: "Browse properties", de: "Immobilien ansehen", ru: "К объектам" },
    cta_contact: { es: "Hablar con un asesor", en: "Speak with an advisor", de: "Berater kontaktieren", ru: "Связаться с советником" },
  },
  featured: {
    label: { es: "Selección actual", en: "Current Selection", de: "Aktuelle Auswahl", ru: "Актуальный выбор" },
    title: { es: "Propiedades destacadas", en: "Featured properties", de: "Ausgewählte Immobilien", ru: "Избранные объекты" },
    view_all: { es: "Ver todas", en: "View all", de: "Alle ansehen", ru: "Смотреть все" },
  },
  properties: {
    heading: { es: "Villas & Apartamentos", en: "Villas & Apartments", de: "Villen & Apartments", ru: "Виллы и апартаменты" },
    mallorca_only: {
      es: "Nuestra selección de venta se concentra exclusivamente en Mallorca. Para oportunidades en otras geografías, visite Inversiones.",
      en: "Our sales portfolio is dedicated to Mallorca only. For opportunities in other geographies, please see Investments.",
      de: "Unser Verkaufsportfolio konzentriert sich ausschließlich auf Mallorca. Für Objekte in anderen Regionen besuchen Sie bitte Investments.",
      ru: "Продажа — только на Майорке. Объекты в других странах и городах — во вкладке «Инвестиции».",
    },
    filter_type: { es: "Tipo", en: "Type", de: "Typ", ru: "Тип" },
    filter_location: { es: "Ubicación", en: "Location", de: "Ort", ru: "Локация" },
    filter_all: { es: "Todas", en: "All", de: "Alle", ru: "Все" },
    villa: { es: "Villas", en: "Villas", de: "Villen", ru: "Виллы" },
    apartment: { es: "Apartamentos", en: "Apartments", de: "Apartments", ru: "Апартаменты" },
    penthouse: { es: "Áticos", en: "Penthouses", de: "Penthäuser", ru: "Пентхаусы" },
    townhouse: { es: "Casas adosadas", en: "Townhouses", de: "Reihenhäuser", ru: "Таунхаусы" },
    finca: { es: "Fincas", en: "Fincas", de: "Fincas", ru: "Финки" },
    chalet: { es: "Chalets", en: "Chalets", de: "Chalets", ru: "Шале" },
    plot_land: { es: "Parcelas", en: "Plots / Land", de: "Grundstücke", ru: "Участки" },
    commercial: { es: "Comerciales", en: "Commercial", de: "Gewerbe", ru: "Коммерческая" },
    offmarket: { es: "Off-Market", en: "Off-Market", de: "Off-Market", ru: "Off-Market" },
    status_reserved: { es: "Reservado", en: "Reserved", de: "Reserviert", ru: "Забронировано" },
    status_sold: { es: "Vendido", en: "Sold", de: "Verkauft", ru: "Продано" },
    bedrooms: { es: "hab.", en: "bd", de: "Zi.", ru: "спл." },
    bathrooms: { es: "baños", en: "ba", de: "Bad", ru: "сан." },
    area: { es: "m² construidos", en: "built m²", de: "Wohnfl. m²", ru: "м² жил." },
    plot: { es: "m² parcela", en: "plot m²", de: "Grundst. m²", ru: "м² уч." },
    ref: { es: "Ref.", en: "Ref.", de: "Ref.", ru: "Ref." },
    request_info: { es: "Solicitar información", en: "Request information", de: "Informationen anfragen", ru: "Запросить информацию" },
    no_results: { es: "No hay resultados.", en: "No results found.", de: "Keine Ergebnisse.", ru: "Ничего не найдено." },
    inquire: { es: "Consultar sobre esta propiedad", en: "Inquire about this property", de: "Zu dieser Immobilie anfragen", ru: "Запросить об этом объекте" },
    search_placeholder: { es: "Buscar por referencia, ubicación o título…", en: "Search by reference, location or title…", de: "Nach Referenz, Ort oder Titel suchen…", ru: "Поиск по референсу, локации или названию…" },
    search_go: { es: "Buscar", en: "Search", de: "Suchen", ru: "Найти" },
    filter_amenity: { es: "Servicios", en: "Amenities", de: "Ausstattung", ru: "Удобства" },
    reset: { es: "Restablecer", en: "Reset", de: "Zurücksetzen", ru: "Сбросить" },
  },
  amenities: {
    pool: { es: "Piscina", en: "Pool", de: "Pool", ru: "Бассейн" },
    parking: { es: "Aparcamiento", en: "Parking", de: "Parkplatz", ru: "Парковка" },
    elevator: { es: "Ascensor", en: "Elevator", de: "Aufzug", ru: "Лифт" },
    sea_view: { es: "Vista al mar", en: "Sea view", de: "Meerblick", ru: "Вид на море" },
    exclusive: { es: "Exclusivo", en: "Exclusive", de: "Exklusiv", ru: "Эксклюзив" },
    garden: { es: "Jardín", en: "Garden", de: "Garten", ru: "Сад" },
    terrace: { es: "Terraza", en: "Terrace", de: "Terrasse", ru: "Терраса" },
    ac: { es: "Aire acondicionado", en: "Air conditioning", de: "Klimaanlage", ru: "Кондиционер" },
    heating: { es: "Calefacción", en: "Heating", de: "Heizung", ru: "Отопление" },
    security: { es: "Seguridad", en: "Security", de: "Sicherheitssystem", ru: "Охрана" },
    gym: { es: "Gimnasio", en: "Gym", de: "Fitnessraum", ru: "Спортзал" },
    spa: { es: "Spa", en: "Spa", de: "Spa", ru: "Спа" },
    sauna: { es: "Sauna", en: "Sauna", de: "Sauna", ru: "Сауна" },
    wine_cellar: { es: "Bodega", en: "Wine cellar", de: "Weinkeller", ru: "Винный погреб" },
    home_cinema: { es: "Cine en casa", en: "Home cinema", de: "Heimkino", ru: "Домашний кинотеатр" },
    smart_home: { es: "Domótica", en: "Smart home", de: "Smart Home", ru: "Умный дом" },
    solar_panels: { es: "Paneles solares", en: "Solar panels", de: "Solaranlage", ru: "Солнечные панели" },
    staff_quarters: { es: "Dependencias de servicio", en: "Staff quarters", de: "Personalunterkunft", ru: "Помещения для персонала" },
    beach_access: { es: "Acceso a la playa", en: "Beach access", de: "Strandzugang", ru: "Выход к пляжу" },
    year_built: { es: "Año de construcción", en: "Year built", de: "Baujahr", ru: "Год постройки" },
    videos: { es: "Videos", en: "Videos", de: "Videos", ru: "Видео" },
  },
  offmarket: {
    label: { es: "Confidencial", en: "Confidential", de: "Vertraulich", ru: "Конфиденциально" },
    title: {
      es: "Oportunidades off-market",
      en: "Off-market opportunities",
      de: "Off-Market-Gelegenheiten",
      ru: "Off-market возможности",
    },
    body: {
      es: "Un porfolio silencioso, disponible únicamente bajo solicitud. Requerimos NDA antes de compartir los detalles.",
      en: "A quiet portfolio, available strictly by request. We share details under NDA.",
      de: "Ein diskretes Portfolio — ausschließlich auf Anfrage. Details unter NDA.",
      ru: "Закрытый портфель — доступ по запросу. Детали под NDA.",
    },
    cta: { es: "Solicitar acceso", en: "Request access", de: "Zugang anfragen", ru: "Запросить доступ" },
  },
  investments: {
    label: { es: "Para Inversores", en: "For Investors", de: "Für Investoren", ru: "Для инвесторов" },
    title: {
      es: "Oportunidades de inversión globales",
      en: "Global investment opportunities",
      de: "Globale Investment-Opportunitäten",
      ru: "Инвестиционные возможности по всему миру",
    },
    body: {
      es: "Oportunidades abiertas y cerradas fuera de Mallorca — Dubái, Miami, Londres, Tulum, Bali y más. Cifras y estructuras revisadas por nuestro equipo antes de presentarlas.",
      en: "Open and closed opportunities beyond Mallorca — Dubai, Miami, London, Tulum, Bali and more. Underwriting and structures reviewed by our team before we present them.",
      de: "Offene und geschlossene Deals außerhalb Mallorcas — Dubai, Miami, London, Tulum, Bali und mehr. Zahlen und Strukturen werden vor der Vorstellung von unserem Team geprüft.",
      ru: "Открытые и закрытые сделки за пределами Майорки — Дубай, Майами, Лондон, Тулум, Бали и другие города. Цифры и структуры мы проверяем до презентации.",
    },
    open: { es: "Oportunidades abiertas", en: "Open opportunities", de: "Offene Chancen", ru: "Открытые возможности" },
    closed: { es: "Cerradas — bajo NDA", en: "Closed — NDA only", de: "Geschlossen — nur NDA", ru: "Закрытые — только по NDA" },
    yield: { es: "Rentabilidad", en: "Yield", de: "Rendite", ru: "Доходность" },
    ticket: { es: "Ticket", en: "Ticket", de: "Ticket", ru: "Тикет" },
    horizon: { es: "Horizonte", en: "Horizon", de: "Horizont", ru: "Горизонт" },
    cta: { es: "Recibir memorándum", en: "Request memorandum", de: "Memorandum anfordern", ru: "Запросить меморандум" },
  },
  rentals: {
    label: { es: "Alquileres selectos · Mallorca", en: "Curated rentals · Mallorca", de: "Ausgewählte Mieten · Mallorca", ru: "Отборная аренда · Майорка" },
    title: {
      es: "Casas para alquilar en Mallorca",
      en: "Homes to rent in Mallorca",
      de: "Häuser zur Miete auf Mallorca",
      ru: "Дома в аренду на Майорке",
    },
    body: {
      es: "Villas y residencias de temporada en Mallorca — Deià, Sóller, Port d'Andratx, Puerto Portals, Palma — con staff, chef y concierge dedicado.",
      en: "Seasonal villas and residences across Mallorca — Deià, Sóller, Port d'Andratx, Puerto Portals, Palma — with staff, chef and dedicated concierge.",
      de: "Saisonale Villen und Residenzen auf Mallorca — Deià, Sóller, Port d'Andratx, Puerto Portals, Palma — mit Personal, Küchenchef und Concierge.",
      ru: "Сезонные виллы и резиденции на Майорке — Дейя, Сольер, Порт-д'Андрач, Puerto Portals, Пальма — с персоналом, шефом и приватным консьержем.",
    },
    per_week: { es: "por semana", en: "per week", de: "pro Woche", ru: "в неделю" },
    per_month: { es: "por mes", en: "per month", de: "pro Monat", ru: "в месяц" },
    per_night: { es: "por noche", en: "per night", de: "pro Nacht", ru: "за ночь" },
    from: { es: "Desde", en: "From", de: "Ab", ru: "От" },
    filter_country: { es: "Zona", en: "Area", de: "Gebiet", ru: "Локация" },
    cta: { es: "Consultar disponibilidad", en: "Check availability", de: "Verfügbarkeit anfragen", ru: "Уточнить доступность" },
  },
  services: {
    label: { es: "Concierge & Lifestyle", en: "Concierge & Lifestyle", de: "Concierge & Lifestyle", ru: "Консьерж и лайфстайл" },
    title: { es: "Servicios en la isla", en: "Services on the island", de: "Services auf der Insel", ru: "Сервисы на острове" },
    housewatch: {
      title: { es: "Cuidado de la vivienda", en: "House watch & management", de: "Hausbetreuung & Verwaltung", ru: "Присмотр за домом" },
      desc: {
        es: "Mantenimiento periódico, jardinería, piscina, seguridad e inventario mientras usted no está.",
        en: "Scheduled maintenance, gardens, pool, security and inventory while you're away.",
        de: "Regelmäßige Wartung, Gärten, Pool, Sicherheit & Inventar in Ihrer Abwesenheit.",
        ru: "Обслуживание, сад, бассейн, охрана и инвентарь в ваше отсутствие.",
      },
    },
    yacht: {
      title: { es: "Alquiler de yates", en: "Yacht charter", de: "Yachtcharter", ru: "Аренда яхт" },
      desc: {
        es: "Selección privada de yates a motor y vela, con capitán y tripulación.",
        en: "Curated fleet of motor and sailing yachts, captain and crew included.",
        de: "Kuratierte Flotte von Motor- und Segelyachten mit Kapitän und Crew.",
        ru: "Подобранный флот моторных и парусных яхт с капитаном и экипажем.",
      },
    },
    excursions: {
      title: { es: "Excursiones", en: "Excursions", de: "Ausflüge", ru: "Экскурсии" },
      desc: {
        es: "Rutas privadas por la Serra de Tramuntana, calas escondidas y bodegas locales.",
        en: "Private trips across Tramuntana, hidden coves and local wineries.",
        de: "Private Touren durch die Tramuntana, versteckte Buchten und lokale Weingüter.",
        ru: "Приватные маршруты по Трамунтане, скрытые бухты и местные винодельни.",
      },
    },
    jets: {
      title: { es: "Aviación privada", en: "Private aviation", de: "Privatjets", ru: "Частные самолёты" },
      desc: {
        es: "Vuelos ejecutivos hacia y desde Mallorca, en pocas horas.",
        en: "Executive flights to and from Mallorca, arranged within hours.",
        de: "Executive-Flüge von und nach Mallorca — innerhalb weniger Stunden.",
        ru: "Бизнес-перелёты в/из Майорки — организуем за часы.",
      },
    },
    cars: {
      title: { es: "Coches premium", en: "Premium cars", de: "Premium-Fahrzeuge", ru: "Премиум-авто" },
      desc: {
        es: "Flota de vehículos premium y deportivos con entrega en la villa.",
        en: "Premium and sports vehicles delivered to your villa.",
        de: "Premium- und Sportfahrzeuge, an Ihre Villa geliefert.",
        ru: "Премиум и спортивные авто с доставкой на виллу.",
      },
    },
    mortgage: {
      title: { es: "Financiación & hipotecas", en: "Financing & mortgages", de: "Finanzierung & Hypotheken", ru: "Ипотека и финансирование" },
      desc: {
        es: "Acceso a bancos privados españoles e internacionales, condiciones para no residentes.",
        en: "Access to Spanish private banks and international lenders, non-resident structuring.",
        de: "Zugang zu spanischen Privatbanken und internationalen Finanzierern, auch für Nicht-Residenten.",
        ru: "Доступ к испанским и международным приватным банкам, ипотека для нерезидентов.",
      },
    },
    renovation: {
      title: { es: "Reformas & renovaciones", en: "Renovations & refurbishment", de: "Sanierung & Renovierung", ru: "Ремонт и реновации" },
      desc: {
        es: "Reformas integrales llave en mano — rápido, con garantía y sin sorpresas en la factura final.",
        en: "Full turnkey renovations — fast, guaranteed, and with no surprises on the final invoice.",
        de: "Schlüsselfertige Komplettsanierungen — schnell, garantiert und ohne Überraschungen bei der Endabrechnung.",
        ru: "Реновации «под ключ» — быстро, качественно, без сюрпризов в финальном счёте.",
      },
    },
    request: { es: "Solicitar servicio", en: "Request service", de: "Service anfragen", ru: "Запросить сервис" },
  },
  about: {
    label: { es: "Sobre nosotros", en: "About", de: "Über uns", ru: "О нас" },
    title: { es: "JK Invest Group", en: "JK Invest Group", de: "JK Invest Group", ru: "JK Invest Group" },
    body_a: {
      es: "Somos una consultora inmobiliaria y de lifestyle basada en Mallorca. Trabajamos con un número reducido de clientes al año, con la calma y la discreción que sus decisiones merecen.",
      en: "We are a real estate and lifestyle consultancy based in Mallorca. We work with a small number of clients each year, with the calm and discretion their decisions deserve.",
      de: "Wir sind eine Immobilien- und Lifestyle-Beratung mit Sitz auf Mallorca. Wir arbeiten mit einer begrenzten Anzahl an Kunden pro Jahr — mit der Ruhe und Diskretion, die ihre Entscheidungen verdienen.",
      ru: "Мы — консалтинг по недвижимости и лайфстайлу с базой на Майорке. Работаем с ограниченным числом клиентов в год, спокойно и приватно.",
    },
    body_b: {
      es: "Nuestro trabajo va desde encontrar la propiedad correcta hasta gestionar la vida en la isla: la casa, los desplazamientos, los detalles.",
      en: "Our work spans from finding the right property to managing life on the island — the home, the movement, the details.",
      de: "Unsere Arbeit reicht vom richtigen Objekt bis zur Verwaltung Ihres Lebens auf der Insel — das Zuhause, die Mobilität, die Details.",
      ru: "Мы отвечаем и за поиск объекта, и за жизнь на острове: дом, перемещения, детали.",
    },
  },
  contact: {
    label: { es: "Contacto", en: "Contact", de: "Kontakt", ru: "Контакты" },
    title: { es: "Empecemos una conversación", en: "Let's start a conversation", de: "Beginnen wir ein Gespräch", ru: "Давайте начнём разговор" },
    name: { es: "Nombre", en: "Name", de: "Name", ru: "Имя" },
    email: { es: "Correo", en: "Email", de: "E-Mail", ru: "Email" },
    phone: { es: "Teléfono", en: "Phone", de: "Telefon", ru: "Телефон" },
    message: { es: "Mensaje", en: "Message", de: "Nachricht", ru: "Сообщение" },
    service: { es: "Servicio de interés", en: "Service of interest", de: "Interessierter Service", ru: "Интересующий сервис" },
    send: { es: "Enviar", en: "Send", de: "Senden", ru: "Отправить" },
    sending: { es: "Enviando…", en: "Sending…", de: "Wird gesendet…", ru: "Отправка…" },
    sent: { es: "Gracias — le responderemos en breve.", en: "Thank you — we'll be in touch shortly.", de: "Danke — wir melden uns in Kürze.", ru: "Спасибо — мы скоро свяжемся." },
    error: { es: "No se pudo enviar. Inténtelo de nuevo.", en: "Could not send. Please try again.", de: "Konnte nicht gesendet werden. Bitte erneut versuchen.", ru: "Не удалось отправить. Попробуйте ещё раз." },
    whatsapp: { es: "Escribir por WhatsApp", en: "Message on WhatsApp", de: "Per WhatsApp schreiben", ru: "Написать в WhatsApp" },
    whatsapp_prefill: {
      es: "Hola JK Invest Group, me interesan sus servicios.",
      en: "Hello JK Invest Group, I'm interested in your services.",
      de: "Hallo JK Invest Group, ich interessiere mich für Ihre Dienstleistungen.",
      ru: "Здравствуйте, JK Invest Group! Меня интересуют ваши услуги.",
    },
    general: { es: "Consulta general", en: "General inquiry", de: "Allgemeine Anfrage", ru: "Общий запрос" },
  },
  footer: {
    rights: { es: "Todos los derechos reservados.", en: "All rights reserved.", de: "Alle Rechte vorbehalten.", ru: "Все права защищены." },
  },
  admin: {
    title: { es: "Panel de administración", en: "Admin panel", de: "Administrations­bereich", ru: "Панель администратора" },
    login: { es: "Introduzca el token de administrador", en: "Enter admin token", de: "Admin-Token eingeben", ru: "Введите админ-токен" },
    login_btn: { es: "Entrar", en: "Sign in", de: "Anmelden", ru: "Войти" },
    logout: { es: "Salir", en: "Sign out", de: "Abmelden", ru: "Выйти" },
    tab_props: { es: "Propiedades", en: "Properties", de: "Immobilien", ru: "Объекты" },
    tab_inq: { es: "Consultas", en: "Inquiries", de: "Anfragen", ru: "Заявки" },
    tab_clients: { es: "Clientes", en: "Clients", de: "Kunden", ru: "Клиенты" },
    new_prop: { es: "Nueva propiedad", en: "New property", de: "Neue Immobilie", ru: "Новый объект" },
    save: { es: "Guardar", en: "Save", de: "Speichern", ru: "Сохранить" },
    cancel: { es: "Cancelar", en: "Cancel", de: "Abbrechen", ru: "Отмена" },
    delete: { es: "Eliminar", en: "Delete", de: "Löschen", ru: "Удалить" },
    edit: { es: "Editar", en: "Edit", de: "Bearbeiten", ru: "Изменить" },
  },
  auth: {
    sign_in: { es: "Iniciar sesión", en: "Sign in", de: "Anmelden", ru: "Войти" },
    sign_up: { es: "Registrarse", en: "Sign up", de: "Registrieren", ru: "Регистрация" },
    sign_out: { es: "Cerrar sesión", en: "Sign out", de: "Abmelden", ru: "Выйти" },
    my_account: { es: "Mi cuenta", en: "My account", de: "Mein Konto", ru: "Мой кабинет" },
    account: { es: "Cuenta", en: "Account", de: "Konto", ru: "Кабинет" },
    hello: { es: "Hola", en: "Hello", de: "Hallo", ru: "Здравствуйте" },
    favorites: { es: "Favoritos", en: "Favorites", de: "Favoriten", ru: "Избранное" },
    empty_favorites: { es: "Todavía no tiene favoritos.", en: "You have no favorites yet.", de: "Sie haben noch keine Favoriten.", ru: "У вас пока нет избранного." },
    password: { es: "Contraseña", en: "Password", de: "Passwort", ru: "Пароль" },
    create_account: { es: "Crear cuenta", en: "Create account", de: "Konto erstellen", ru: "Создать аккаунт" },
    have_account: { es: "¿Ya tiene cuenta?", en: "Already have an account?", de: "Bereits ein Konto?", ru: "Уже есть аккаунт?" },
    no_account: { es: "¿Sin cuenta?", en: "No account?", de: "Noch kein Konto?", ru: "Нет аккаунта?" },
    register_btn: { es: "Registrarse", en: "Create account", de: "Registrieren", ru: "Зарегистрироваться" },
    register_title: { es: "Bienvenido a JK Invest Group", en: "Welcome to JK Invest Group", de: "Willkommen bei JK Invest Group", ru: "Добро пожаловать в JK Invest Group" },
    login_title: { es: "Acceder a su cuenta", en: "Access your account", de: "Ihr Konto öffnen", ru: "Войти в кабинет" },
    welcome_back: { es: "Bienvenido de nuevo", en: "Welcome back", de: "Willkommen zurück", ru: "С возвращением" },
    save_favorite: { es: "Guardar en favoritos", en: "Save to favorites", de: "Zu Favoriten hinzufügen", ru: "В избранное" },
    require_login: { es: "Inicie sesión para guardar.", en: "Sign in to save.", de: "Zum Speichern anmelden.", ru: "Войдите, чтобы сохранять." },
    prop_singular: { es: "propiedad", en: "property", de: "Immobilie", ru: "объект" },
    prop_plural: { es: "propiedades", en: "properties", de: "Immobilien", ru: "объектов" },
  },
  home: {
    global_label: { es: "Portafolio global", en: "Global portfolio", de: "Globales Portfolio", ru: "Глобальный портфель" },
    global_title: { es: "Más allá de la isla.", en: "Beyond the island.", de: "Über die Insel hinaus.", ru: "За пределами острова." },
    global_body: {
      es: "Oportunidades de inversión en todo el mundo y alquileres de temporada en Mallorca.",
      en: "Investment opportunities worldwide, and seasonal rentals across Mallorca.",
      de: "Investment-Chancen weltweit und Saisonmieten auf Mallorca.",
      ru: "Инвестиции по всему миру и сезонная аренда на Майорке.",
    },
  },
  about_section: {
    years: { es: "Años en Mallorca", en: "Years in Mallorca", de: "Jahre auf Mallorca", ru: "Лет на Майорке" },
    volume: { es: "Volumen transaccionado", en: "Transacted volume", de: "Transaktionsvolumen", ru: "Оборот сделок" },
    languages: { es: "Idiomas hablados", en: "Languages spoken", de: "Gesprochene Sprachen", ru: "Языков в команде" },
    referral: { es: "Basado en referencias", en: "Referral-based", de: "Auf Empfehlungsbasis", ru: "Только по рекомендациям" },
    quiet: { es: "Un enfoque discreto para Mallorca.", en: "A quiet approach to Mallorca.", de: "Ein ruhiger Zugang zu Mallorca.", ru: "Тихий подход к Майорке." },
  },
  services_page: {
    hero_a: { es: "La capa", en: "The", de: "Die", ru: "Скрытый" },
    hero_italic: { es: "no dicha", en: "unspoken", de: "unausgesprochene", ru: "невидимый" },
    hero_b: { es: "de la vida en Mallorca.", en: "layer of a Mallorca life.", de: "Schicht eines Lebens auf Mallorca.", ru: "слой жизни на Майорке." },
    subhead: {
      es: "Servicios en la isla. Seis disciplinas, un solo número al que llamar.",
      en: "Services on the island. Six disciplines, one number to call.",
      de: "Services auf der Insel. Sechs Disziplinen, eine Nummer.",
      ru: "Сервисы на острове. Шесть направлений, один номер.",
    },
    note_label: { es: "— Una nota", en: "— A note", de: "— Ein Hinweis", ru: "— Заметка" },
    note: {
      es: "No tenemos un menú de servicios. Tenemos un equipo pequeño, una agenda con las personas adecuadas de la isla — y la obsesión de hacer que las cosas ocurran en silencio, a tiempo y sin dejar rastro.",
      en: "We do not have a menu of services. We have a small team, a black book of the right people on the island — and an obsession with making things happen quietly, on time, and without a trace.",
      de: "Wir haben kein Menü an Dienstleistungen. Wir haben ein kleines Team, ein schwarzes Buch mit den richtigen Menschen auf der Insel — und die Obsession, Dinge leise, pünktlich und spurlos umzusetzen.",
      ru: "У нас нет прайса услуг. У нас небольшая команда, чёрная книжка с нужными людьми на острове — и одержимость делать всё тихо, вовремя, без следа.",
    },
    signature: { es: "— JK Invest Group, Palma de Mallorca", en: "— JK Invest Group, Palma de Mallorca", de: "— JK Invest Group, Palma de Mallorca", ru: "— JK Invest Group, Пальма-де-Майорка" },
    chapter: { es: "Capítulo", en: "Chapter", de: "Kapitel", ru: "Глава" },
    numbers_label: { es: "En números", en: "In numbers", de: "In Zahlen", ru: "В цифрах" },
    numbers_title: { es: "Un conserje que lleva la cuenta.", en: "A concierge that keeps score.", de: "Ein Concierge, der die Zeit im Blick hat.", ru: "Консьерж, который держит счёт." },
    stat_1: { es: "Tiempo medio de respuesta", en: "Median response time", de: "Mediane Antwortzeit", ru: "Среднее время ответа" },
    stat_2: { es: "Cobertura del cuidado del hogar", en: "House-watch coverage", de: "Hausbetreuung", ru: "Присмотр за домом" },
    stat_3: { es: "Proveedores verificados en la isla", en: "Verified suppliers on island", de: "Verifizierte Partner auf der Insel", ru: "Проверенных подрядчиков на острове" },
    stat_4: { es: "Política de discreción con clientes", en: "Client discretion policy", de: "Diskretionsrichtlinie", ru: "Политика приватности клиентов" },
    quote_by: { es: "— Cliente, 2024", en: "— Client, 2024", de: "— Kunde, 2024", ru: "— Клиент, 2024" },
    quote: {
      es: "«Anticiparon tres problemas que yo aún no sabía que iba a tener. Nunca vi los correos. De eso se trata.»",
      en: "\u201cThey anticipated three problems I did not know I was about to have. I never saw the emails. That is the whole point.\u201d",
      de: "\u201eSie haben drei Probleme antizipiert, von denen ich noch nichts wusste. Ich habe die E-Mails nie gesehen. Das ist der Punkt.\u201c",
      ru: "«Они предугадали три проблемы, о которых я ещё не знал. Я не видел этих писем. В этом весь смысл.»",
    },
    cta_full_contact: { es: "Contactar directamente", en: "Contact directly", de: "Direkt kontaktieren", ru: "Связаться напрямую" },
    cta_body: {
      es: "Cuéntenos qué necesita atender. Le respondemos personalmente — nunca desde un buzón compartido.",
      en: "Tell us what you'd like taken care of. We reply personally — never from a shared inbox.",
      de: "Sagen Sie uns, worum wir uns kümmern sollen. Wir antworten persönlich — nie aus einem geteilten Postfach.",
      ru: "Расскажите, что нужно решить. Мы отвечаем лично — не из общей почты.",
    },
  },
  investments_page: {
    reviewed: { es: "Revisado por analistas de JK Invest", en: "Reviewed by JK Invest analysts", de: "Von JK-Invest-Analysten geprüft", ru: "Проверено аналитиками JK Invest" },
    opportunities_1: { es: "oportunidad", en: "opportunity", de: "Gelegenheit", ru: "возможность" },
    opportunities_n: { es: "oportunidades", en: "opportunities", de: "Gelegenheiten", ru: "возможностей" },
    closed_title: { es: "Deals que no publicamos.", en: "Deals we don't publish.", de: "Deals, die wir nicht veröffentlichen.", ru: "Сделки, которые мы не публикуем." },
    request_confidential: { es: "Solicitar acceso confidencial", en: "Request confidential access", de: "Vertraulichen Zugang anfragen", ru: "Запросить конфиденциальный доступ" },
    memorandum_title: { es: "Solicite el memorándum para inversores.", en: "Request the investor memorandum.", de: "Fordern Sie das Investor-Memorandum an.", ru: "Запросите инвестиционный меморандум." },
    memorandum_body: {
      es: "Compartimos análisis, estructura y referencias del promotor bajo NDA.",
      en: "We share underwriting, structure and sponsor references under NDA.",
      de: "Wir teilen Underwriting, Struktur und Sponsor-Referenzen unter NDA.",
      ru: "Обмениваемся анализом, структурой и референсами спонсора под NDA.",
    },
  },
  rentals_page: {
    availability: { es: "Disponibilidad & conserjería.", en: "Availability & concierge.", de: "Verfügbarkeit & Concierge.", ru: "Доступность и консьерж." },
    availability_body: {
      es: "Indíquenos las fechas, el número de huéspedes y la ubicación preferida — le enviamos una preselección en 24 horas.",
      en: "Tell us your dates, party size and preferred destination — we return with a shortlist within 24 hours.",
      de: "Nennen Sie uns Ihre Daten, Gästezahl und Wunschort — wir melden uns innerhalb von 24 Stunden mit einer Auswahl.",
      ru: "Пришлите даты, размер компании и локацию — мы вернёмся с шортлистом за 24 часа.",
    },
    type_all: { es: "Todos", en: "All", de: "Alle", ru: "Все" },
    type_villa: { es: "Villas", en: "Villas", de: "Villen", ru: "Виллы" },
    type_apartment: { es: "Apartamentos", en: "Apartments", de: "Apartments", ru: "Апартаменты" },
    filter_type: { es: "Tipo", en: "Type", de: "Typ", ru: "Тип" },
  },
  property_detail: {
    features: { es: "Características", en: "Features", de: "Ausstattung", ru: "Особенности" },
    price_on_request: { es: "Precio a consultar", en: "Price on request", de: "Preis auf Anfrage", ru: "Цена по запросу" },
  },
  offmarket_page: {
    nda_required: { es: "NDA requerido", en: "NDA required", de: "NDA erforderlich", ru: "Требуется NDA" },
    confidential_title: { es: "Solicitar acceso confidencial", en: "Request confidential access", de: "Vertraulichen Zugang anfragen", ru: "Запросить конфиденциальный доступ" },
  },
  contact_page: {
    office: { es: "Oficina", en: "Office", de: "Büro", ru: "Офис" },
    office_addr: {
      es: "Palma de Mallorca\nIlles Balears, España",
      en: "Palma de Mallorca\nIlles Balears, Spain",
      de: "Palma de Mallorca\nIlles Balears, Spanien",
      ru: "Пальма-де-Майорка\nИлес-Балеарес, Испания",
    },
  },
};

export function t(key, lang) {
  const parts = key.split(".");
  let node = dict;
  for (const p of parts) {
    node = node?.[p];
    if (node == null) return key;
  }
  if (typeof node === "string") return node;
  return node[lang] ?? node.en ?? key;
}
